import { render, staticRenderFns } from "./Translate.vue?vue&type=template&id=05abaa74&"
import script from "./Translate.vue?vue&type=script&lang=js&"
export * from "./Translate.vue?vue&type=script&lang=js&"
import style0 from "./Translate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports